export default "__VITE_ASSET__dcfab942__"